import React from 'react';
import BalanceSheet from './Balance_Sheet';
import '../../../CommonCSS/SocietyCSS.css'

const BalSheetApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Balance Sheet</h5>
          </div>
        </div>
        <BalanceSheet />
      </div>
    </div >
  );
};

export default BalSheetApp;
